import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import {
  ActionExtractDataNormalizer,
  IActionExtractDataParams
} from './client';

const createActionExtractDataActualNameBase = (expr?: string): string => {
  return expr || '';
};

export const createActionExtractDataActualName: ActualNameCreator<
  IActionExtractDataParams
> = ({ params }) => createActionExtractDataActualNameBase(params.text?.expr);

export const normalizeActionExtractData: ActionExtractDataNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionExtractDataActualNameBase(raw.params.text.expr),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
